/**
 * Toast notification component
 */

import React from 'react';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';
import { clsx } from 'clsx';
import { useToastStore, Toast as ToastType } from '../../stores/toast';

export function ToastContainer() {
  const { toasts, removeToast } = useToastStore();

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onClose={() => removeToast(toast.id)} />
      ))}
    </div>
  );
}

function Toast({ toast, onClose }: { toast: ToastType; onClose: () => void }) {
  const icons = {
    success: <CheckCircle className="h-5 w-5 text-green-500" />,
    error: <AlertCircle className="h-5 w-5 text-red-500" />,
    warning: <AlertTriangle className="h-5 w-5 text-yellow-500" />,
    info: <Info className="h-5 w-5 text-blue-500" />,
  };

  const bgColors = {
    success: 'bg-success-light border-success-main',
    error: 'bg-error-light border-error-main',
    warning: 'bg-warning-light border-warning-main',
    info: 'bg-info-light border-info-main',
  };

  return (
    <div
      className={clsx(
        'flex items-start gap-3 p-4 rounded-lg border shadow-lg max-w-md',
        bgColors[toast.type]
      )}
    >
      {icons[toast.type]}
      <div className="flex-1">
        <p className="font-semibold text-theme-text">{toast.title}</p>
        {toast.message && <p className="text-sm text-theme-text-secondary mt-1">{toast.message}</p>}
      </div>
      <button onClick={onClose} className="text-theme-text-secondary hover:text-theme-text">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}


